import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Navigate, useNavigate, useParams, Link } from "react-router-dom";
import API from "../../services/axiosInstance";
import { FormLoader, useFormLoader } from "../common_modules/loader";
import { loggedInUserDetails } from "../utils/helper";
import Permission from "../security/permission";
import { AUTH_CODE } from "../security/authCodes";
import { useAuth } from "../security/authContext";
// import useSubmitPrevent from "../utils/SubmitPrevent";
import usePreventMultiClick from "../utils/SubmitPrevent";

const ACCOUNT_TYPE_ID = 1; // (Publisher user's)

const PublisherForm = ({
    mode = 'add',
    defaultValues = {},
    publisherId = null,
    publisherGuid = null,
}) => {
    const navigate = useNavigate();
    const { id, guid } = useParams();
    const [roleSet, setRoleSet] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [roleSetLoaded, setRoleSetLoaded] = useState(false);
    // custom hook loader
    const { isLoading, startLoading, stopLoading } = useFormLoader();
    const { hasPermission } = useAuth();

    const { register, handleSubmit, reset, watch, formState: { errors, dirtyFields }, } = useForm({ defaultValues });

    const password = watch("password");
    const paymentType = watch("paymentType");

    // const submittingRef = useSubmitPrevent();
    const { btnClicked, setBtnClicked } = usePreventMultiClick();
    // role set list api 
    const roleSetList = async () => {
        // const roleSetListRes = await API.get('/tech/roles/set/list/limited');
        // console.log(roleSetListRes.data?.data);        
        // setRoleSet(roleSetListRes?.data?.data);
        // setRoleSetLoaded(true);
        const roleSetListRes = await API.get(`tech/roles/set/list/limited?id=${ACCOUNT_TYPE_ID}`);
        if (roleSetListRes.status === 200) {
            setRoleSet(roleSetListRes?.data?.data);
            setRoleSetLoaded(true)
        }
    }

    // roles list api 
    const roleListFn = async () => {
        const roleListRes = await API.get('/tech/users/user/accounts/list');
        setRoleList(roleListRes?.data?.data);
    }

    const paymentPaylod = (data) => {
        switch (data.paymentType) {
            case 1:
                return {
                    paymentType: 1,
                    paypalId: data.paypalId?.trim(),
                };
            case 2:
                return {
                    paymentType: 2,
                    bankBeneficiaryName: data.bankBeneficiaryName?.trim(),
                    bankAccountNo: data.bankAccountNo?.trim(),
                    bankName: data.bankName?.trim(),
                    bankAddress: data.bankAddress?.trim(),
                    bankBranchNo: data.bankBranchNo?.trim(),
                    bankVatNo: data.bankVatNo?.trim(),
                };
            case 3:
                return {
                    paymentType: 3,
                    wireBeneficiaryName: data.wireBeneficiaryName?.trim(),
                    wireAccountNo: data.wireAccountNo?.trim(),
                    wireBankName: data.wireBankName?.trim(),
                    wireBankAddress: data.wireBankAddress?.trim(),
                    swiftCode: data.swiftCode?.trim(),
                    iban: data.iban?.trim(),
                };
            default:
                return {
                    paymentType: 0,
                };
        }
    }

    // get user type 
    const user = loggedInUserDetails();
    const userType = user?.accountType;

    useEffect(() => {
        if (mode === "edit" && defaultValues && roleSetLoaded) {
            // reset(defaultValues);
            reset({
                ...defaultValues,
                roleSetList: (defaultValues.roleSetList),
            });
        }
    }, [mode, defaultValues, roleSetLoaded, reset]);

    useEffect(() => {
        Promise.all([roleSetList(), roleListFn()]);
        //    roleSetList(); 
        //    roleListFn();
    }, []);

    const hasOnlySpaces = (obj) => {
        for (const [key, value] of Object.entries(obj)) {

            // check only strings
            if (typeof value === "string") {

                // ignore completely empty fields
                if (value === "") continue;

                // block only spaces
                if (value.trim() === "") {
                    return key;
                }
            }
        }

        return null;
    };
    const fieldLabels = {
        name: "Account Name",
        userId: "User ID",
        companyName: "Company Name",
        payoneerId: "Payoneer ID",
        contactDetail: "Contact Person Detail",
    };
    const onSubmit = async (data) => {
        if(btnClicked) return;
        setBtnClicked(true);
        // if (submittingRef.current) return;
        // submittingRef.current = true;
        startLoading();
        const invalidField = hasOnlySpaces(data);
        if (invalidField) {
            stopLoading();
            alert(`${fieldLabels[invalidField] || invalidField} cannot contain only spaces`);
            setBtnClicked(false);
            return;
        }
            // Common trim function
            const trimPayload = (payload) => {
            return Object.fromEntries(
                Object.entries(payload).map(([key, value]) => [
                    key,
                    typeof value === "string" ? value.trim() : value
                ])
            );
        };
        const payload = {
            name: data.name,
            userId: data.userId,
            email: data.email,
            password: data.password || "",
            roleSetId: data.roleSetList,
            phone: data.phone,
            contactDetail: data.contactDetail,
            companyName: data.companyName,
            brand: data.brand,
            city: data.city,
            country: data.country,
            address: data.address,
            payoneerId: data.payoneerId,
            accountType: ACCOUNT_TYPE_ID,
            // languageType: 1,
            ...paymentPaylod(data)
        };
        if (mode === "add") {
            payload.password = data.password;
        }
        if (mode === "edit") {
            payload.id = publisherId;
            payload.guid = publisherGuid;
            // only send if user actually typed something
            // if (data.password && data.password.trim() !== "") {
            //     payload.password = data.password;
            // }
            // Only send password when creating OR when user enters it
            if (data.password && dirtyFields.password) {
                payload.password = data.password;
            }
        }
        // Automatically trim all string values
        const cleanedPayload = trimPayload(payload);
        try {
            const apiCall =
                mode === "add"
                    ? API.post("/publisher/add/account", cleanedPayload)
                    : API.put('/publisher/update', cleanedPayload);
            const response = await apiCall;
            if (response?.data?.status === "Success") {
                alert(response?.data?.message || "Success");
                navigate(-1);
                // if (hasPermission(AUTH_CODE.accounts.publisherListing)) {
                // } else {
                //     navigate("-1");
                // }

            } else {
                alert(response?.data?.message || "Failed");
            }
        } catch (error) {
            alert(error?.response?.data?.message || "Something went wrong!");
        } finally {
            // submittingRef.current = false;
            setBtnClicked(false);
            stopLoading();
        }
    };

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <Link to={'/active-publisher'}><span>Publisher</span></Link>
                <Link to={`/publisher/info/${id}/${guid}`}>{mode === "edit" ? <span>{defaultValues?.name}</span> : ''}</Link>
                <span>{mode === "edit" ? "Update" : "Create"}</span>
                {/* {mode === "edit" ? <span>{id}</span> : ''} */}

            </div>
            <Card className="p-3 instreamRows">
                <span className="text-danger mb-3" style={{ fontSize: "12px" }}>All fields marked with * are mandatory</span>
                <h6 className="title mb-5">Account Information</h6>
                <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                    <input type="text" autoComplete="username" style={{ display: "none" }} />
                    <input type="password" autoComplete="current-password" style={{ display: "none" }} />
                    <Card className="p-3">
                        <h6 className="subTitle">Account Information</h6>
                        {/* Account Name */}
                        <Row>
                            <Col md={3}>
                                <label>Account Name <span className="text-danger">*</span></label>
                            </Col>
                            <Col md={5}>
                                <Form.Control type="text" placeholder="Enter here..." {...register("name", { required: "Account Name is required" })} />
                                {errors.name && <p className="text-danger">{errors.name.message}</p>}
                            </Col>
                        </Row>
                        {/* User ID */}
                        <Row>
                            <Col md={3}>
                                <label>User ID <span className="text-danger">*</span></label>
                            </Col>
                            <Col md={5}>
                                <Form.Control type="text" placeholder="Enter here..." autoComplete="new-username" {...register("userId", { required: "User ID is required" })} disabled={mode === "edit"} />
                                {errors.userId && <p className="text-danger">{errors.userId.message}</p>}
                            </Col>
                        </Row>

                        {
                            // <Permission code={AUTH_CODE.accounts.updatePassword}>
                            ((userType !== 1 && hasPermission(AUTH_CODE.accounts.updatePassword)) || !id) && (
                                <>
                                    <Row>
                                        <Col md={3}>
                                            <label>Password {mode === "add" && <span className="text-danger">*</span>}</label>
                                        </Col>
                                        <Col md={5}>
                                            <Form.Control type="password" placeholder={mode === "edit" ? "Leave blank to keep existing password" : "Enter here..."} autoComplete="off" {...register("password", {
                                                required: mode === "add" ? "Password is required" : false,
                                                minLength: {
                                                    value: 6,
                                                    message: "Password must be at least 6 characters"
                                                }
                                            })} />
                                            {errors.password && <p className="text-danger">{errors.password.message}</p>}
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={3}>
                                            <label>Confirm Password {mode === "add" && <span className="text-danger">*</span>}</label>
                                        </Col>
                                        <Col md={5}>
                                            <Form.Control type="password" placeholder={mode === "edit" ? "Leave blank to keep existing password" : "Enter here..."} autoComplete="off" {...register("confirmPassword", {
                                                required: mode === "add" ? "Confirm Password is required" : false,
                                                validate: (value) =>
                                                    value === password || "Passwords do not match"
                                            })} />
                                            {errors.confirmPassword && <p className="text-danger">{errors.confirmPassword.message}</p>}
                                        </Col>
                                    </Row>
                                </>
                            )
                        }
                    </Card>

                    {userType !== 1 && (
                        <Card className="p-3 mt-5">
                            <h6 className="subTitle">Roles</h6>
                            {/* Role */}
                            <Row>
                                <Col md={3}>
                                    <label>Role<span className="text-danger">*</span></label>
                                </Col>
                                <Col md={5}>
                                    {/* <Controller className ="fieldFont" name = "roleSetId" control={control} rules={{ required: "Please select at least one" }} render= {({ field }) =>(
                                    <Select className ="fieldFont basic-multi-select" classNamePrefix="select" {...field} isMulti={false} options={roles}  isSearchable ={false} placeholder="Please Select"/>
                                    )} /> */}
                                    <Form.Select {...register("roleSetList", { required: "Role set is required" })}>
                                        <option value="">Please Select</option>
                                        {
                                            roleSet?.map((roleSet) => (
                                                <option key={roleSet?.id} value={roleSet.id}>
                                                    {roleSet.roleSetName}
                                                </option>
                                            ))
                                        }
                                    </Form.Select>
                                    {errors.roleSetList && <p className="text-danger">{errors.roleSetList.message}</p>}
                                </Col>
                            </Row>
                        </Card>
                    )}
                    <Card className="p-3 mt-5">
                        <h6 className="subTitle">Contact Information</h6>
                        {/* Payoneer ID */}
                        <Row>
                            <Col md={3}>
                                <label>Payoneer ID </label>
                            </Col>
                            <Col md={5}>
                                <Form.Control type="text" placeholder="Enter here..." {...register("payoneerId")} />
                                {errors.payoneerId && <p className="text-danger">{errors.payoneerId.message}</p>}

                            </Col>
                        </Row>
                        {/* Email ID */}
                        <Row>
                            <Col md={3}>
                                <label>Email ID <span className="text-danger">*</span></label>
                            </Col>
                            <Col md={5}>
                                <Form.Control as="textarea" rows={6} placeholder="Enter here..." {...register("email", {
                                    required: "Email is required",
                                    validate: (value) => {
                                        const emails = value
                                            .split("\n")
                                            .map((email) => email.trim())
                                            .filter((email) => email !== "");

                                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                                        const invalidEmail = emails.find(
                                            (email) => !emailRegex.test(email)
                                        );

                                        return (
                                            !invalidEmail || `Invalid email: ${invalidEmail}`
                                        );
                                    }
                                })} />
                                <small class="help-inline small" style={{ color: "#767676", fontSize: "10px" }}>each line is 1 email ID using enter key</small>
                                {errors.email && <p className="text-danger">{errors.email.message}</p>}

                            </Col>
                        </Row>
                        {/* Contact Number */}
                        <Row>
                            <Col md={3}>
                                <label>Contact Number</label>
                            </Col>
                            <Col md={5}>
                                <Form.Control type="number" placeholder="Enter here..." {...register("phone",
                                    {
                                        minLength: {
                                            value: 10,
                                            message: "Phone number must be 10 digits"
                                        },
                                        maxLength: {
                                            value: 10,
                                            message: "Phone number must be 10 digits"
                                        },
                                        pattern: {
                                            value: /^[0-9]+$/,
                                            message: "Only numbers are allowed"
                                        }
                                    }
                                )} />
                                {errors.phone && <p className="text-danger">{errors.phone.message}</p>}

                            </Col>
                        </Row>
                        {/* Contact Person Detail */}
                        <Row>
                            <Col md={3}>
                                <label>Contact Person Detail</label>
                            </Col>
                            <Col md={5}>
                                <Form.Control type="text" placeholder="Enter here..." {...register("contactDetail",
                                    // {required: "contact Person is required"}
                                )} />
                                {/* {errors.contactDetail && <p className="text-danger">{errors.contactDetail.message}</p>} */}

                            </Col>
                        </Row>
                    </Card>
                    <Card className="p-3 mt-5">
                        <h6 className="subTitle">Company Information</h6>
                        {/* Contact Person Detail */}
                        <Row>
                            <Col md={3}>
                                <label>Company Name (legal name) <span className="text-danger">*</span></label>
                            </Col>
                            <Col md={5}>
                                <Form.Control type="text" placeholder="Enter here..." {...register("companyName", {
                                    required: "Company name is required"
                                })} />
                                {errors.companyName && <p className="text-danger">{errors.companyName.message}</p>}

                            </Col>
                        </Row>
                        {/* Brand Name */}
                        <Row>
                            <Col md={3}>
                                <label>Brand Name</label>
                            </Col>
                            <Col md={5}>
                                <Form.Control type="text" placeholder="Enter here..." {...register("brand",
                                    // {required: "Brand name is required"}
                                )} />
                                {/* {errors.brand && <p className="text-danger">{errors.brand.message}</p>} */}

                            </Col>
                        </Row>
                        {/* City Name */}
                        <Row>
                            <Col md={3}>
                                <label>City Name</label>
                            </Col>
                            <Col md={5}>
                                <Form.Control type="text" placeholder="Enter here..." {...register("city",
                                    // {required: "City name is required"}
                                )} />
                                {/* {errors.city && <p className="text-danger">{errors.city.message}</p>} */}

                            </Col>
                        </Row>
                        {/* Country Name */}
                        <Row>
                            <Col md={3}>
                                <label>Country Name</label>
                            </Col>
                            <Col md={5}>
                                <Form.Control type="text" placeholder="Enter here..." {...register("country",
                                    // {required: "Country name is required"}
                                )} />
                                {/* {errors.country && <p className="text-danger">{errors.country.message}</p>} */}

                            </Col>
                        </Row>
                        {/* Company Address */}
                        <Row>
                            <Col md={3}>
                                <label>Company Address</label>
                            </Col>
                            <Col md={5}>
                                <Form.Control as="textarea" rows={6} placeholder="Enter here..." {...register("address",
                                )} />

                            </Col>
                        </Row>
                    </Card>
                    <Card className="p-3 mt-5">
                        <h6 className="subTitle">Payment Information</h6>
                        <Row>
                            <Col md={3}>
                                <label>Payment Type</label>
                            </Col>
                            <Col md={5}>
                                <Form.Select {...register("paymentType", { valueAsNumber: true })}>
                                    <option value={0}>NothingSelected</option>
                                    <option value={1}>Paypal</option>
                                    <option value={2}>BankTransfer</option>
                                    <option value={3}>WireTransfer</option>
                                </Form.Select>
                            </Col>
                        </Row>
                        {paymentType === 1 && (
                            <Row>
                                <h6>Paypal Information</h6>
                                <Col md={3}>
                                    <label>Paypal Id</label>
                                </Col>
                                <Col md={5}>
                                    <Form.Control type="text" placeholder="Enter here..." {...register("paypalId")} />
                                </Col>
                            </Row>
                        )}

                        {paymentType === 2 && (
                            <>
                                <h6>Bank Transfer Information</h6>
                                <Row>
                                    <Col md={3}>
                                        <label>Beneficiary Name</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Control type="text" placeholder="Enter here..." {...register("bankBeneficiaryName")} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <label>Account Number</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Control type="text" placeholder="Enter here..." {...register("bankAccountNo")} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <label>Bank Name</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Control type="text" placeholder="Enter here..." {...register("bankName")} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <label>Bank Address</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Control type="text" placeholder="Enter here..." {...register("bankAddress")} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <label>Branch Number</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Control type="text" placeholder="Enter here..." {...register("bankBranchNo")} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <label>Vat Number</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Control type="text" placeholder="Enter here..." {...register("bankVatNo")} />
                                    </Col>
                                </Row>
                            </>
                        )}
                        {paymentType === 3 && (
                            <>
                                <h6>Wire Transfer Information</h6>
                                <Row>
                                    <Col md={3}>
                                        <label>Beneficiary Name</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Control type="text" placeholder="Enter here..." {...register("wireBeneficiaryName")} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <label>Account Number</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Control type="text" placeholder="Enter here..." {...register("wireAccountNo")} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <label>Bank Name</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Control type="text" placeholder="Enter here..." {...register("wireBankName")} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <label>Bank Address</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Control type="text" placeholder="Enter here..." {...register("wireBankAddress")} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <label>Swift Code</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Control type="text" placeholder="Enter here..." {...register("swiftCode")} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <label>IBAN</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Control type="text" placeholder="Enter here..." {...register("iban")} />
                                    </Col>
                                </Row>
                            </>
                        )}

                    </Card>
                    <Button type="submit" variant="primary" disabled = {btnClicked} className="mt-3 submitBtn" size="lg">{mode === "add" ? "Create" : "Update"}</Button>
                    <Button type="button" variant="secondary" className="mx-5 mt-3 cancelBtn" onClick={() => navigate(-1)}>Cancel</Button>
                </form>
            </Card>
        </FormLoader>
    )
}

export default PublisherForm;